import { t } from 'src/i18n';
import { RecentWrapper } from './globalSearchRecent.style';

const GlobalSearchRecent = ({ recent }) => {
  return (
    <RecentWrapper>
      <span className="recent-header">{t('dash.globalSearch.recent_label')}</span>
      {recent?.length === 0 && <span className="recent-message">{t('dash.globalSearch.recents_message')}</span>}
    </RecentWrapper>
  );
};

export default GlobalSearchRecent;
